import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useRef, useState } from "react";
import { DossierItemType } from "dto/Dossier/DossierItemType";
import StatusBadge from "components/StatusBadge";
import Popper from "components/Popper";
import StatusModal from "components/StatusModal";
import { IStatus } from "dto/IStatus";
import { Tooltip } from "@mui/material";
import { ListType } from "dto/ListType";

const StatusCell: FC<Props> = ({ element, statuses, apiRef }) => {
  const refStatus = useRef(null);
  const [showStatus, setShowStatus] = useState<boolean>(false);
  const [status, setStatus] = useState<IStatus>(
    statuses.find((s) => s.Id === element.StatusId)
  );

  const handleStatusUpdate = (status?: IStatus) => {
    console.log("Handle status update", status);
    // const rows = Object.values(
    //   gridRowsLookupSelector(apiRef)
    // ) as IDossierItem[];

    // var toUpdate = rows.find((x) => x.DossierId === element.DossierId);

    // if (toUpdate) {
    //   toUpdate.StatusId = status?.Id;

    apiRef.current.dataSource.cache.clear();
    // apiRef.current.updateRows([
    //   { id: element.DossierId, StatusId: status?.Id },
    // ]);
    //}

    setStatus(status);
    setShowStatus(false);
  };

  if (element.Type === DossierItemType.Folder) {
    return <></>;
  }

  return (
    <div className={styles.status}>
      {status && (
        <div
          ref={refStatus}
          className={styles.badge}
          onClick={(e) => {
            setShowStatus(!showStatus);
            e.stopPropagation();
          }}
        >
          {status && <StatusBadge status={status} showName={true} />}
        </div>
      )}
      {!status && element.Type !== DossierItemType.Link && (
        <Tooltip title="Ustaw status">
          <div>
            <div
              ref={refStatus}
              className={styles.fakeBadge}
              onClick={(e) => {
                setShowStatus(!showStatus);
                e.stopPropagation();
              }}
            >
              ...
            </div>
          </div>
        </Tooltip>
      )}

      {showStatus && (
        <Popper
          anchorEl={refStatus?.current}
          open={showStatus}
          setOpen={setShowStatus}
        >
          <StatusModal
            listType={ListType.EditorDocuments}
            item={element}
            toggle={setShowStatus}
            selectedStatus={status}
            afterUpdate={handleStatusUpdate}
          />
        </Popper>
      )}
    </div>
  );
};

export default StatusCell;
